"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const toObject_1 = __importDefault(require("dayjs/plugin/toObject"));
const parsingFormatOptions = {
    date: ['DD.MM.YYYY', 'YYYY.MM.DD', 'DD-MM-YYYY', 'YYYY-MM-DD'],
    time: ['HH:mm'],
    datetime: ['DD.MM.YYYY HH:mm', 'YYYY.MM.DD HH:mm', 'DD-MM-YYYY HH:mm', 'YYYY-MM-DD HH:mm']
};
const parseToLocalePlugin = (options, dayjsClass, dayjsFactory) => {
    const METHOD_NAME_PREFIX = 'parseLocale';
    const methodNames = [
        'parseLocaleTime',
        'parseLocaleDate',
        'parseLocaleDateTime'
    ];
    const defaultParse = dayjsClass.prototype.parse;
    let passedDate = null;
    // Default parser is override to capture passed date, and will be invoked without any changes
    dayjsClass.prototype.parse = function (cfg) {
        passedDate = cfg.date;
        defaultParse.call(this, cfg);
    };
    methodNames.forEach((methodName) => {
        dayjsClass.prototype[methodName] = function () {
            const format = methodName.replace(METHOD_NAME_PREFIX, '').toLowerCase();
            return dayjsFactory(passedDate, parsingFormatOptions[format]);
        };
    });
};
dayjs_1.default.extend(toObject_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(parseToLocalePlugin);
